<template>
    <section v-if="content" class="collection-slider-sec">

        <div class="container">
            <div class="collection-slider-sec__big-image">
                <picture>
                    <source :srcset="content.image.webp" type="image/webp">
                    <img :src="content.image.jpeg" :alt="content.title"
                         class="collection-slider-sec__big-image-element">
                </picture>
            </div>
            <div class="collection-slider-sec__info">
                <div class="sec-title-container">
                    <span class="sec-title-container__dop-text">{{ content.title }}</span>
                    <h2 class="sec-title">{{ content.description }}</h2>
                    <p class="sec-title-container__subtitle">{{ content.surtitle }}</p>
                </div>
                <div class="collection-slider-sec__slider_wrapper">
                    <div class="collection-slider-sec__slider">

                        <swiper
                            class="swiper-viewed_products swiper swiper-initialized swiper-horizontal product-row firm-sec_row product-mob-slider swiper-backface-hidden "
                            :modules="modules"
                            :slidesPerView="2"

                            :pagination="{ clickable: true }"

                        >

                            <swiper-slide class="swiper-slide product" v-for="(card, cardIndex) in content.cards" :key="card.id">
                                <div class="swiper-slide product swiper-slide-prev">
                                    <a :href="card.slug" target="_self"
                                       :title="card.name" class="product__wrapper"
                                       @click="onSelectItem(card, cardIndex)">
                                        <div class="product__image_wrapper" >


                                            <picture class="product__image product__first-image">
                                                <source
                                                    :srcset="card.img_first.webp"
                                                    type="image/webp">

                                                <img :src="card.img_first.jpeg"
                                                     :alt="card.name"
                                                     class="product__image product__first-image">
                                            </picture>
                                            <picture class="product__image product__second-image">
                                                <source
                                                    :srcset="card.img_last.webp"
                                                    type="image/webp">

                                                <img :src="card.img_last.jpeg"
                                                     :alt="card.name"
                                                     class="product__image product__second-image">
                                            </picture>

                                            <span v-if="checkFavourites(card)"  @click.prevent="updateLike(card)" :class="card.favourites ? 'active-like' : '' " class="add-like ">
                                                    <svg class="svg-icon" width="22" height="18" viewBox="0 0 22 18"
                                                         fill="none" xmlns="http://www.w3.org/2000/svg"><path
                                                        d="M11 17.25C11 17.25 1.625 12 1.625 5.62501C1.625 4.49803 2.01546 3.40585 2.72996 2.53431C3.44445 1.66277 4.43884 1.0657 5.54393 0.844677C6.64903 0.623658 7.79657 0.792346 8.79131 1.32204C9.78605 1.85174 10.5665 2.70972 11 3.75001V3.75001C11.4335 2.70972 12.2139 1.85174 13.2087 1.32204C14.2034 0.792346 15.351 0.623658 16.4561 0.844677C17.5612 1.0657 18.5555 1.66277 19.27 2.53431C19.9845 3.40585 20.375 4.49803 20.375 5.62501C20.375 12 11 17.25 11 17.25Z"
                                                        stroke="black" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round"></path>
                                                    </svg>
                                                </span>

                                        </div>
                                        <div class="product__info">
                                            <h3 class="product__title">
                                                <span class="product__title-link">{{ card.name }}</span>
                                            </h3>
                                            <div class="product__price-row">
                                                <template v-if="card.offer.price_old_str">
                                                    <p class="product__sale-price product__text-def">
                                                        <span v-if="card.isPricesDifferent">от </span>
                                                        {{ card.offer.price_str }} {{ card.signs }}
                                                    </p>
                                                    <p class="product__old-price"> {{ card.offer.price_old_str }} {{ card.signs }}</p>
                                                </template>

                                                <p class="product__main-price product__text-def" v-if="!card.offer.price_old_str">
                                                    <span v-if="card.isPricesDifferent">от </span> {{ card.offer.price_str }} {{ card.signs }}
                                                </p>

                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </swiper-slide>


                        </swiper>
                    </div>
                </div>
            </div>


        </div>
    </section>
</template>

<script>import {Navigation, Pagination} from 'swiper/modules';

// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from 'swiper/vue';
import { selectItem, viewItemList } from '../../services/ga4Ecommerce.js';

// Import Swiper styles
import 'swiper/css';
// import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';
import 'swiper/css';
// import 'swiper/swiper-bundle.css';
export default {
    props: {
        content: {
            type: Object,
        },


    },
    components: {

        Swiper,
        SwiperSlide,


    },
    data() {
        return {
            modules: [Navigation, Pagination],

        }
    },
    methods:{
        checkFavourites(card){

            if (this.$store.state.settings.basket.favourites.find(it => it.card_id === card.id)) {

                card.favourites = true
            }
            return true
        },
        updateLike(card){
            card.favourites = !card.favourites
            this.$parent.$parent.$refs.header.updateLike(card)
        },
        onSelectItem(card, index) {
            selectItem(card, 'home_collection', this.content?.title || this.content?.description || 'Collection', index + 1)
        },
    },
    name: "collection-slider-sec",
    watch: {
        content: {
            immediate: true,
            handler(content) {
                if (content?.cards?.length) {
                    viewItemList(content.cards, 'home_collection', content.title || content.description || 'Collection')
                }
            },
        },
    },
}
</script>

<style scoped>
.product__image_wrapper{
    max-height: 420px;
}
</style>
